// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../Types/generated-types'

import gql from 'graphql-tag'
import * as Urql from 'urql'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
export type SupportedCurrenciesQueryVariables = Types.Exact<{ [key: string]: never }>

export type SupportedCurrenciesQuery = {
  __typename?: 'Query'
  supportedCurrencies: Array<{
    __typename?: 'Currency'
    code: Types.SupportedCurrencyCode
    symbol: string
    order: number
  }>
}

export type ExchangeRatesQueryVariables = Types.Exact<{ [key: string]: never }>

export type ExchangeRatesQuery = {
  __typename?: 'Query'
  exchangeRates: Array<{
    __typename?: 'ExchangeRate'
    rate: number
    currency: {
      __typename?: 'Currency'
      code: Types.SupportedCurrencyCode
      symbol: string
      order: number
    }
  }>
}

export const SupportedCurrenciesDocument = gql`
  query SupportedCurrencies {
    supportedCurrencies {
      code
      symbol
      order
    }
  }
`

export function useSupportedCurrenciesQuery(
  options?: Omit<Urql.UseQueryArgs<SupportedCurrenciesQueryVariables>, 'query'>
) {
  return Urql.useQuery<SupportedCurrenciesQuery, SupportedCurrenciesQueryVariables>({
    query: SupportedCurrenciesDocument,
    ...options,
  })
}
export const ExchangeRatesDocument = gql`
  query ExchangeRates {
    exchangeRates {
      currency {
        code
        symbol
        order
      }
      rate
    }
  }
`

export function useExchangeRatesQuery(
  options?: Omit<Urql.UseQueryArgs<ExchangeRatesQueryVariables>, 'query'>
) {
  return Urql.useQuery<ExchangeRatesQuery, ExchangeRatesQueryVariables>({
    query: ExchangeRatesDocument,
    ...options,
  })
}
